import { render, staticRenderFns } from "./WarehousesLayout.vue?vue&type=template&id=dcb3046c&scoped=true&"
import script from "./WarehousesLayout.vue?vue&type=script&lang=js&"
export * from "./WarehousesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3046c",
  null
  
)

export default component.exports